import { aiPromptManagerReducer } from '../container/screen/LLM/PromptManager/logic/PromptManager.reducer';
import { authMiddleware } from '../container/screen/Auth/logic/auth.middleware';
import { configureStore } from '@reduxjs/toolkit';
import { Service } from '../service/service';
import accountSwitcherReducer from '../container/screen/Users/subcomponents/AccountSwitcher/logic/AccountSwitcher.reducer';
import authReducer from '../container/screen/Auth/logic/Auth.reducer';
import baseReducer from './BaseReducer';
import contactReducer from '../container/screen/Contact/logic/Contact.reducer';
import createAccountReducer from '../container/screen/Users/subcomponents/CreateAccount/logic/CreateAccount.reducer';
import projectReducer from '../container/screen/Project/logic/Project.reducer';
import portfolioReducer from '../container/screen/Portfolio/logic/Portfolio.reducer';
import templateEngineReducer from '../container/screen/TemplateEngine/logic/TemplateEngine.reducer';

export const store = configureStore({
  reducer: {
    base: baseReducer,
    auth: authReducer,
    aiPromptManagerReducer: aiPromptManagerReducer.reducer,
    contact: contactReducer,
    accountSwitcher: accountSwitcherReducer,
    createAccount: createAccountReducer,
    project: projectReducer,
    portfolio: portfolioReducer,
    templateEngine: templateEngineReducer,
    [Service.reducerPath]: Service.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authMiddleware).concat([Service.middleware]),
  devTools: process.env.REACT_APP_ENVIRONMENT !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
